import { createSvgIcon } from "@mui/material";

export const TransparencyIcon = createSvgIcon(
  <svg viewBox="0 0 18 18" fill="none">
    <path
      d="M3.44727 0.317383V3.70801H6.83789V0.317383H10.2285V3.70801H13.6192V0.317383H15.3145C17.0098 0.317383 17.0098 2.01269 17.0098 2.01269V3.70801H13.6192V7.09864H17.0098V10.4893H13.6192V13.8799H17.0098V15.5752C17.0098 15.5752 17.0098 17.2705 15.3145 17.2705H13.6192V13.8799H10.2285V17.2705H6.83789V13.8799H3.44727V17.2705H1.75195C0.0566404 17.2705 0.0566406 15.5752 0.0566406 15.5752V13.8799H3.44727V10.4893H0.0566406V7.09864H3.44727V3.70801H0.0566406V2.01269C0.0566406 2.01269 0.0605469 0.317383 1.75195 0.317383H3.44727ZM6.83789 7.09864H10.2285V3.70801H6.83789V7.09864ZM6.83789 10.4893V7.09864H3.44727V10.4893H6.83789ZM10.2285 10.4893H6.83789V13.8799H10.2285V10.4893ZM10.2285 10.4893H13.6192V7.09864H10.2285V10.4893Z"
      fill="currentColor"
    />
  </svg>,
  "TransparencyIcon",
);
